import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import ContractForm from "./ContractForm";
import ContractPreview from "./ContractPreview";
import { Box, Drawer, useMediaQuery } from "@mui/material";
import HistoryTable from "./HistoryTable";

const ContractDrafting = () => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const dispatch = useDispatch();

  const selectedContract = useSelector((state) => state.selectedContract);
  const { selectedApp } = selectedContract;

  const newContractRequest = useSelector(
    (state) => state.newContractRequest
  );
  const { isClicked } = newContractRequest;

  const [readOnly, setReadOnly] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [generatedContract, setGeneratedContract] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isHistoryClicked, setIsHistoryClicked] = useState(true);
  const [contractToEdit, setContractToEdit] = useState({});
  const [openSidebar, setOpenSidebar] = useState(false);
  // New state for desktop sidebar
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setOpenSidebar((prev) => !prev);
  };

  const toggleDesktopSidebar = () => {
    setSidebarCollapsed((prev) => !prev);
  };

  useEffect(() => {
    if (isClicked) {
      setGeneratedContract("");
      dispatch({ type: "SELECTED_CONTRACT_RESET" });
      dispatch({ type: "NEW_CONTRACT_RESET" });
    }
    if (isHistoryClicked) {
      dispatch({ type: "SELECTED_CONTRACT_RESET" });
    }
  }, [isClicked, dispatch, isHistoryClicked]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        width: "100%",
       backgroundColor: "#F8FAFC",
      }}
    >
      {isMobileView ? (
        <Drawer
          anchor="left"
          open={openSidebar}
          ModalProps={{
            keepMounted: true,
          }}
          onClose={toggleSidebar}
        >
          <Sidebar
            toggleSidebar={toggleSidebar}
            setIsHistoryClicked={setIsHistoryClicked}
            setContractToEdit={setContractToEdit}
            setGeneratedContract={setGeneratedContract}
            readOnly={readOnly}
            setReadOnly={setReadOnly}
          />
        </Drawer>
      ) : (
        <Sidebar
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleDesktopSidebar}
          setIsHistoryClicked={setIsHistoryClicked}
          setContractToEdit={setContractToEdit}
          setGeneratedContract={setGeneratedContract}
          readOnly={readOnly}
          setReadOnly={setReadOnly}
        />
      )}
      {isHistoryClicked ? (
        <HistoryTable
          toggleSidebar={toggleSidebar}
          setContractToEdit={setContractToEdit}
          setIsHistoryClicked={setIsHistoryClicked}
        />
      ) : isMobileView && (selectedApp || generatedContract) ? (
        <ContractPreview
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          readOnly={readOnly}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          setReadOnly={setReadOnly}
          generatedContract={generatedContract}
          setGeneratedContract={setGeneratedContract}
          isGenerating={isGenerating}
          contractToEdit={contractToEdit}
          setContractToEdit={setContractToEdit}
        />
      ) : isMobileView ? (
        <ContractForm
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          setGeneratedContract={setGeneratedContract}
          setIsGenerating={setIsGenerating}
          isGenerating={isGenerating}
          readOnly={readOnly}
          setReadOnly={setReadOnly}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      ) : (
        <React.Fragment>
          <ContractForm
            isCollapsed={sidebarCollapsed}
            setGeneratedContract={setGeneratedContract}
            setIsGenerating={setIsGenerating}
            isGenerating={isGenerating}
            readOnly={readOnly}
            setReadOnly={setReadOnly}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
          />
          <ContractPreview
            isCollapsed={sidebarCollapsed}
            readOnly={readOnly}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            setReadOnly={setReadOnly}
            generatedContract={generatedContract}
            setGeneratedContract={setGeneratedContract}
            isGenerating={isGenerating}
            contractToEdit={contractToEdit}
            setContractToEdit={setContractToEdit}
          />
        </React.Fragment>
      )}
    </Box>
  );
};

export default ContractDrafting;
